<template>
	<div class="header mb-5">
		<div id="header" class="mb-5">
			<div v-if="uploadRequest" class="overlay"></div>
			<div id="header_wrapper">
				<div class="container">
					<a class="open_menu" data-bs-toggle="offcanvas" href="#mobile_menu_sidebar">
						<span class="icon"></span>
					</a>
					<a class="logo_container" @click="returnHome()">
						<img src="@/assets/3dlogo.png" class="image-logo">
					</a>
					<div class="main_menu" v-html="wpMenu"></div>
					<div class="main_menu_social" v-html="socialMenu"></div>
					<div class="buttons_list">
						<button class="button upload-button generic"><a @click="showUpload()">Upload</a></button>
						<button class="button generic"><a @click="logout()">Logout</a></button>
					</div>
				</div>
			</div>


		</div>
		<fileUploader v-if="uploadRequest" @closeUpload="closeUploadWindow" :uploadUrl="uploadUrl" :subscription="subscription"></fileUploader>
	</div>
</template>

<script>
import commonProps from '../common/common.js'
import fileUploader from '../components/FileUploader.vue'
import axios from 'axios'
const common = new commonProps();
export default {
	name:'header-component',
	components: {
		fileUploader
	},
	data() {
		return {
			uploadRequest: false,
			uploadUrl:'',
			isAllowed:false,
			wpMenu:'',
			subscription:{},
			cmplz_statistics:'',
			cmplz_marketing:''
		}
	},
	mounted() {
		//axios .get(`${common.supervisorApi}rest/get_active_subscription`)
		axios .get(`${common.supervisorApi}rest/get_subscription_details`)
					.then(result => {
						if (result.data && !result.data.error) {
							this.isAllowed=true
							this.subscription = result.data
							//pass email to GTM
							if (this.$gtm.enabled()) {
								window.dataLayer?.push({
									'event' : 'userEmailAvailable',
									'visitorEmail': this.subscription.data.email,
									'visitorLoginState': 'logged-in',
									'plan': this.getSubscriptionName(this.subscription.data.subscription_type) 
								});
								if (this.cmplz_statistics=='allow'){
									window.dataLayer?.push({
										'event' : 'cmplz_event_statistics',
									});
								}
								if (this.cmplz_marketing=='allow'){
									window.dataLayer?.push({
										'event' : 'cmplz_event_marketing',
									});
								}
							}
						}
					})
		this.getWpMenu()
		this.getConsent()
	},
	methods: {
		getWpMenu() {
			axios .get(`${common.wpApi}header_menu`)
						.then(result => {
							if (result.data)
								this.wpMenu = result.data
						})
		},
		returnHome() {
			location.href = location.origin
		},
		showUpload() {
			axios .get(`${common.supervisorApi}rest/get_admin_token`)
						.then(result => {
							if (result.data && !result.data.error) {
								const token = result.data.data.token;
								axios .get(`${common.supervisorApi}rest/get_customer_id_by_email`)
											.then(result => {
												if (result.data && !result.data.error) {
													const customerID = result.data.data.customer_id;
													this.uploadUrl = `${common.modelApi}?token=${token}&customerID=${customerID}`
													this.uploadRequest = true
												}
											})
							}
						})
		},
		logout() {
			axios .get(`${common.supervisorApi}users/logout`)
						.then((result) => {
							if (result.data && !result.data.error)
								location.href=result.data.data

						})
		},
		closeUploadWindow() {
			this.uploadRequest = false
			this.$emit('closeUpload')
		},
		getConsent(){
			this.cmplz_statistics=common.getCookie('cmplz_statistics')
			this.cmplz_marketing=common.getCookie('cmplz_marketing')
			//console.log(cmplz_statistics,cmplz_marketing)
		},
		getSubscriptionName(subscription_type){
			if (subscription_type===1){ //subscription is premium		
				return 'Premium'
			} else if (subscription_type===2){ //subscription is business	
				return 'Business' 
			} else { // trial or regular	
				return 'Free'
			} 
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/header.scss';

</style>
